export class Alternative {
	public _id: string
	public name: string
	public media_url: string
	public category_id: string
	public subCategory_id: string
}
